function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import messages from '../../messages';
import * as selectors from '../../selectors';
import * as shapes from '../../shapes';
import styles from './NoSharingRequests.pcss';
var _React_PureComponent;
class NoSharingRequests extends (_React_PureComponent = React.PureComponent) {
    render() {
        if (this.props.sharingRequests.length || this.props.isInProgress) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.root,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "w-100",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/assets/svg/no-people.svg",
                        className: styles.icon,
                        alt: ""
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.noSharingRequests))
                })
            ]
        });
    }
}
_define_property(NoSharingRequests, "propTypes", {
    // Implicit props
    sharingRequests: PropTypes.arrayOf(shapes.sharingRequest),
    isInProgress: PropTypes.bool
});
const mapStateToProps = (state)=>({
        sharingRequests: selectors.sharingRequests(state),
        isInProgress: selectors.isFetchSharingRequestsInProgress(state)
    });
const ConnectedNoSharingRequests = connect(mapStateToProps)(NoSharingRequests);
export default withStyles(styles)(ConnectedNoSharingRequests);
